import { typographyV2 } from '@toggle/design-system';
import styled from 'styled-components';

import { ScrollingView } from '~/components/scrolling-view/ScrollingView';

export const Root = styled(ScrollingView)`
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 20px;
  width: 100%;
  max-width: var(--chat-message-width);
`;

export const NewSession = styled.p`
  display: flex;
  justify-content: center;
  border-bottom: 1px solid var(--border-default);
  width: 100%;
  max-width: 920px;
  margin: 44px 0px;
  & span {
    ${typographyV2.uiSm}
    border: solid 1px green;
    border: 1px solid var(--border-default);
    background: black;
    margin-bottom: -14px;
    padding: 4px 8px;
    border-radius: 8px;
  }
`;

export const AbortMessage = styled.p`
  color: var(--text-soft);
`;
